import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Col, Divider, Modal, Row, Spin } from 'antd';
import GoldLeague from './Assets/goldLeague.png';
import BronzeLeague from './Assets/bronzeLeague.png';
import DiamondLeague from './Assets/diamondLeague.png';
import PlatinumLeague from './Assets/platinumLeague.png';
import SilverLeague from './Assets/silverLeague.png';
import BlueLeague from './Assets/blueLeague.png';
import Aeroplance from './Assets/aeroplane.png';
import Medical from './Assets/medical.png';
import Shield from './Assets/shield.png';
import Beach from './Assets/beach.png';
import InfoIcon from './Assets/infoIcon.png';
import GoldLock from './Assets/GoldLock.png';
import BronzeLock from './Assets/BronzeLock.png';
import DiamondLock from './Assets/DiamondLock.png';
import SilverLock from './Assets/SilverLock.png';
import PlatinumLock from './Assets/PlatinumLock.png';
import shopInsurance from './Assets/shopInsurance.png';
import staffInsurance from './Assets/staffInsurance.png';

import { SocialMediaButtons } from './Component/socialMedia/socialMediaShare';

import { Container } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { UserTypeDict } from '../../../utils/settings';
import { LockOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../screen/distributor/view/SchemeBenefit/Benefits.less';
import { GetInsuranceCertificateAction,
  getBenefitsDataOfUser,
  GetAllUserInsuranceCertificate,
  getAmountForMedicalInsurance
 } from './APIs/action';

const imageObj = (val) => {
  if (val === 'ब्रॉन्ज़') return BronzeLeague;
  if (val === 'प्लैटिनम') return PlatinumLeague;
  if (val === 'सिल्वर') return SilverLeague;
  if (val === 'डायमंड') return DiamondLeague;
  if (val === 'ब्लू') return BlueLeague;
  if (val === 'गोल्ड') return GoldLeague;

  return GoldLeague;
};
const lockImageObj = (val) => {
  if (val === 'ब्रॉन्ज़') return BronzeLock;
  if (val === 'प्लैटिनम') return PlatinumLock;
  if (val === 'सिल्वर') return SilverLock;
  if (val === 'डायमंड') return DiamondLock;
  if (val === 'ब्लू') return DiamondLock;
  if (val === 'गोल्ड') return GoldLock;

  return GoldLock;
};
const overlayColorObj = (val) => {
  if (val === 'ब्रॉन्ज़') return 'rgba(147, 77, 17, 0.3)';
  if (val === 'प्लैटिनम') return 'rgba(229, 225, 230,0.3)';
  if (val === 'सिल्वर') return 'rgba(196, 188, 183,0.4)';
  if (val === 'डायमंड') return 'rgba(171, 202, 233, 0.3)';
  if (val === 'ब्लू') return 'rgba(0, 169, 224, 0.2)';
  if (val === 'गोल्ड') return 'rgba(249, 229, 158,0.6)';

  return 'rgba(249, 229, 158,0.6)';
};

const levelText = (val) => {
  if (val === 'ब्रॉन्ज़') return 'BRONZE';
  if (val === 'प्लैटिनम') return 'PLATINUM';
  if (val === 'सिल्वर') return 'SILVER';
  if (val === 'डायमंड') return 'DIAMOND';
  if (val === 'ब्लू') return 'BLUE';
  if (val === 'गोल्ड') return 'GOLD';

  return 'BLUE';
};

const nextLevelText = (val) => {
  if (val === 'ब्लू') return 'BRONZE';
  if (val === 'ब्रॉन्ज़') return 'SILVER';
  if (val === 'सिल्वर') return 'GOLD';
  if (val === 'गोल्ड') return 'PLATINUM';
  if (val === 'प्लैटिनम') return 'DIAMOND';
  if (val === 'डायमंड') return '';

  return 'BLUE';
};

const InsuranceText = (val) => {
  if (val === 'निश्चिंत (जीवन बीमा)') return 'LIFE INSURANCE';
  if (val === 'संजीवनी (स्वास्थ्य बीमा)') return 'MEDICAL INSURANCE';
  if (val === 'सुहाना सफर (वार्षिक टूर)') return 'ANNUAL CONFERENCE';
  if (val === 'संबल/स्वावलंबन (गोल्डन एज प्लान)') return 'GOLDEN AGE PLAN';
  if (val === 'SHOP INSURANCE') return 'SHOP INSURANCE';
  if (val === 'STAFF INSURANCE') return 'STAFF INSURANCE';

  return 'LIFE INSURANCE';
};
const MyBenefits = () => {
  const [benefitsData, setBenefitsData] = useState({});
  const [unfilteredBenefitsData, setUnfilteredBenefitsData] = useState([]);
  const [certificates, setCertificates] = useState([]);

  const [medicalInsuranceAmount, setMedicalInsuranceAmount] = useState();

  const [openModal, setOpenModal] = useState(false);
  const [modalData, setModalData] = useState({});
  const [dataIndex, setDataIndex] = useState(0);

  const [loader, setLoader] = useState(false);

  // const dispatch = useDispatch()

  const navigate = useNavigate();

  const { loginUser } = useSelector((state) => {
    return {
      loginUser: state.loginReducer.loginUser,
    };
  });

  const userCompanyType =
    loginUser &&
    loginUser?.company_details &&
    loginUser?.company_details?.company_type;

  const isRetailerLoggenIn = userCompanyType === UserTypeDict['RETAILER'];
  const isDistributorLoggenIn = userCompanyType === UserTypeDict['DISTRIBUTOR'];

  const downloadHandler = async (file) => {
    await GetInsuranceCertificateAction(
      file.user_certificate_image_s3_id,
      file.filename,
    );
    setOpenModal(false);
  };

  const getMedicalInsuranceAmount = async () => {
    const { data, error, message } = await getAmountForMedicalInsurance();

    if (!error && data.length > 0) {
      setMedicalInsuranceAmount(data[0]);
    }
  };

  const fetchData = async () => {
    setLoader(true);
    const { error, message, data } = await getBenefitsDataOfUser();
    setLoader(false);
    if (!error && Object.keys(data).length > 0) {
      setUnfilteredBenefitsData(data);
      const alteredData = {
        ...data,
        benefit_details: data.benefit_details
          .map((item, index) => {
            if (item.name === 'निश्चिंत (जीवन बीमा)') {
              return {
                ...item,
                // value_or_description: '5 Lakh',
              };
            } else if (item.name === 'संजीवनी (स्वास्थ्य बीमा)') {
              return {
                ...item,
                // value_or_description: '50 Lakh',
              };
            } else if (item.name === 'सुहाना सफर (वार्षिक टूर)') {
              return {
                ...item,
                // value_or_description: 'दुबई की अंतर्राष्ट्रीय यात्रा',
              };
            } else if (item.name === 'संबल/स्वावलंबन (गोल्डन एज प्लान)') {
              return {
                ...item,
                // value_or_description: '₹ 5,000 has been Credited to your A/c',
              };
            } else if (item.name === 'SHOP INSURANCE') {
              return {
                ...item,
                // value_or_description: '₹ 5,000 has been Credited to your A/c',
              };
            } else if (item.name === 'STAFF INSURANCE') {
              return {
                ...item,
                // value_or_description: '₹ 5,000 has been Credited to your A/c',
              };
            }
          })
          .filter((item) => item),
      };
      setBenefitsData(alteredData);
      const response = await GetAllUserInsuranceCertificate();
      setCertificates(response.data);
      return;
    } else {
      setLoader(false);
      toast.error(message);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const HexagonOutline = ({
    width,
    height,
    strokeColor,
    strokeWidth,
    rotation,
    fill = 'transparent',
  }) => {
    const sideLength = Math.min(width, height) / 2;
    const centerX = width / 2;
    const centerY = height / 2;
    const angle = Math.PI / 3;
    const points = [];

    for (let i = 1; i < 7; i++) {
      const x = centerX + sideLength * Math.cos(i * angle);
      const y = centerY + sideLength * Math.sin(i * angle);
      points.push(`${x},${y}`);
    }

    const d = `M${points[0]} L${points[1]} L${points[2]} L${points[3]} L${points[4]} L${points[5]} Z`;

    return (
      <svg
        width={width}
        height={height}
        style={{ position: 'absolute' }}
      >
        <path
          d={d}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          fill={fill}
          transform={`rotate(${rotation}, ${width / 2}, ${height / 2})`}
        />
      </svg>
    );
  };

  const modal = () => {
    let certificateType;

    switch (true) {
      case Array.isArray(benefitsData?.benefit_details) &&
        benefitsData?.benefit_details[dataIndex]?.name ===
          'निश्चिंत (जीवन बीमा)':
        certificateType = 1;
        break;
      case Array.isArray(benefitsData?.benefit_details) &&
        benefitsData?.benefit_details[dataIndex]?.name ===
          'संजीवनी (स्वास्थ्य बीमा)':
        certificateType = 2;
        break;

      case Array.isArray(benefitsData?.benefit_details) &&
        benefitsData?.benefit_details[dataIndex]?.name === 'STAFF INSURANCE':
        certificateType = 8;
        break;

      case Array.isArray(benefitsData?.benefit_details) &&
        benefitsData?.benefit_details[dataIndex]?.name === 'SHOP INSURANCE':
        certificateType = 7;
        break;

      default:
        certificateType = 0;
        break;
    }

    const filter = certificates.filter(
      (item) => item.certificate_type == certificateType,
    );

    const getTotalSumInsured = filter.reduce(
      (prevValue, currentValue) => prevValue + currentValue.amount,
      0,
    );

    const isThereCertificate = filter.length > 0;

    const benefitName =
      Array.isArray(benefitsData?.benefit_details) &&
      benefitsData?.benefit_details.length > 0 &&
      benefitsData?.benefit_details[dataIndex]?.name;

    const convertToLakh = (number) => {
      const lakh = 100000;

      return number / lakh + ' Lakh';
    };

    // const tableData = {
    //   rows: ['Beneficiary Name', 'Amount', 'Action'],
    //   tableData: filter.map((item) => [
    //     item.beneficiary_name ? item.beneficiary_name : '-',
    //     convertToLakh(item.amount),
    //     <DownloadOutlined
    //       style={{ color: 'orange' }}
    //       onClick={() => {
    //         downloadHandler(item);
    //       }}
    //     />,
    //   ]),
    //   onRowClick: (index) => {},
    // };

    const formatEffectiveDate = (date) => moment(date).format('MMMM DD, YYYY');
    const formatEffectiveMonth = (date) => moment(date).format('MMMM, YYYY');

    const isLifeInsurance = benefitName === 'निश्चिंत (जीवन बीमा)';
    const isGoldenAgePlan = benefitName === 'संबल/स्वावलंबन (गोल्डन एज प्लान)';
    const isWorldTour = benefitName === 'सुहाना सफर (वार्षिक टूर)';
    const isHealthInsurance = benefitName === 'संजीवनी (स्वास्थ्य बीमा)';
    const isStaffInsurance = benefitName === 'STAFF INSURANCE';
    const isShopInsurance = benefitName === 'SHOP INSURANCE';

    return (
      <Modal
        title={null}
        footer={null}
        centered
        className='benefits-modal'
        open={openModal}
        onOk={() => setOpenModal(false)}
        onCancel={() => setOpenModal(false)}
      >
        {Array.isArray(benefitsData?.benefit_details) &&
          benefitsData?.benefit_details.length > 0 && (
            <>
              {!unfilteredBenefitsData.show_50pc_gap_benefits_table && (
                <p
                  className='benefitsModalUserName'
                  style={{ margin: 0 }}
                >
                  {isGoldenAgePlan && 'BENEFIT LOCKED'}{' '}
                  {isGoldenAgePlan && (
                    <LockOutlined
                      style={{ color: '#cd996d', fontWeight: 'bold' }}
                    />
                  )}
                </p>
              )}

              {/* Heading */}
              <h2 className='benefitsModalHeader'>{modalData.name}</h2>
              {/* If no benefit is found i.e certificateType is 0 */}
              {certificateType == 0 && !(isGoldenAgePlan || isWorldTour) && (
                <p
                  className='benefitsModalBenefitName'
                  style={{ margin: 0 }}
                >
                  STATUS: NOT ELIGIBLE
                </p>
              )}
              {filter && isLifeInsurance && getTotalSumInsured > 0 && (
                <div className='benefitsModalBenefitName'>
                  TOTAL SUM ASSURED : {convertToLakh(getTotalSumInsured)}
                </div>
              )}
              {filter && isHealthInsurance && getTotalSumInsured > 0 && (
                <div className='benefitsModalBenefitName'>
                  TOTAL SUM ASSURED : {convertToLakh(getTotalSumInsured)}
                </div>
              )}
              {filter && isStaffInsurance && getTotalSumInsured > 0 && (
                <div className='benefitsModalBenefitName'>
                  TOTAL SUM ASSURED : {convertToLakh(getTotalSumInsured)}
                </div>
              )}
              {filter && isShopInsurance && getTotalSumInsured > 0 && (
                <div className='benefitsModalBenefitName'>
                  TOTAL SUM ASSURED : {convertToLakh(getTotalSumInsured)}
                </div>
              )}

              {filter.map((item) => (
                <div style={{ marginTop: 10 }}>
                  {/* BENEFICIARY Name */}
                  <p
                    className='benefitsModalUserName'
                    style={{ marginTop: 0 }}
                  >
                    {(isLifeInsurance ||
                      isHealthInsurance ||
                      isShopInsurance ||
                      isStaffInsurance) &&
                      `BENEFICIARY NAME: 
                    ${isThereCertificate ? item.beneficiary_name : 'NA'} `}
                  </p>

                  {/* Price or Sum for life and Medical insurance */}
                  <p
                    className='benefitsModalBenefitName'
                    style={{ margin: 0 }}
                  >
                    {isLifeInsurance
                      ? item?.amount
                        ? `SUM ASSURED: INR ${item?.amount}`
                        : `SUM ASSURED ELIGIBILITY: INR ${benefitsData.benefit_details[dataIndex]?.value_or_description}`
                      : ''}

                    {isHealthInsurance || isShopInsurance || isStaffInsurance
                      ? isThereCertificate || (item.valid_from && item.valid_to)
                        ? `SUM ASSURED: INR ${convertToLakh(item.amount)}`
                        : `SUM ASSURED ELIGIBILITY: INR ${benefitsData?.benefit_details[dataIndex]?.value_or_description}`
                      : ''}
                  </p>

                  {/* Effective Date for Life and health insurance */}
                  <p
                    className='benefitsModalValidDate'
                    style={{ margin: 0 }}
                  >
                    {(isLifeInsurance ||
                      isHealthInsurance ||
                      isStaffInsurance ||
                      isShopInsurance) &&
                      'EFFECTIVE DATE:'}
                    {isLifeInsurance ||
                    isHealthInsurance ||
                    isStaffInsurance ||
                    isShopInsurance
                      ? (isThereCertificate && item.valid_from) || item.valid_to
                        ? ` ${formatEffectiveDate(item.valid_from)}
                      `
                        : ' NA'
                      : ''}
                  </p>

                  {/* Download button For Certificates */}
                  {(isLifeInsurance ||
                    isHealthInsurance ||
                    isStaffInsurance ||
                    isShopInsurance) && (
                    <div className='displayCenter'>
                      <Button
                        block
                        type='primary'
                        disabled={filter.length <= 0}
                        style={{
                          width: '20rem',
                          marginBottom: '10px',
                          marginTop: '20px',
                        }}
                        onClick={() => {
                          if (filter.length > 0) downloadHandler(item);
                        }}
                      >
                        <b className='btnText'>Download Your Certificate</b>
                      </Button>
                      {/* <div style={{ width: '100%' }}>
                    <OrderBookingTable showShadow data={tableData} />
                  </div> */}
                    </div>
                  )}
                  <Divider />
                </div>
              ))}

              {/* For Golden Age Plan */}
              <p
                className='benefitsModalBenefitName'
                style={{ margin: 0 }}
              >
                {isGoldenAgePlan &&
                  `Evaluated Gross Amount of GAP  - ₹${benefitsData?.benefit_details[dataIndex]?.value_or_description}*`}
              </p>

              {/* for business Perios date */}
              <p
                className='benefitsModalValidDate'
                style={{ margin: 0 }}
              >
                {isWorldTour && 'BUSINESS PERIOD: '}{' '}
                {isWorldTour &&
                  benefitsData.benefit_details.length > 0 &&
                  benefitsData.benefit_details[dataIndex].start_date &&
                  benefitsData.benefit_details[dataIndex].end_date &&
                  `${formatEffectiveMonth(
                    benefitsData.benefit_details[dataIndex].start_date,
                  )} -
                ${formatEffectiveMonth(
                  benefitsData.benefit_details[dataIndex].end_date,
                )}`}
              </p>

              {(isLifeInsurance ||
                isHealthInsurance ||
                isShopInsurance ||
                isStaffInsurance) &&
                filter.length <= 0 && (
                  <p
                    className='benefitsModalBenefitName'
                    style={{ margin: 0 }}
                  >
                    SUM ASSURED ELIGIBILITY: INR{' '}
                    {
                      benefitsData.benefit_details[dataIndex]
                        ?.value_or_description
                    }
                    <br />
                    STATUS: POLICY TO BE ISSUED
                  </p>
                )}

              {isWorldTour && (
                <p className='benefitsModalBenefitName'>
                  ELIGIBILITY:{' '}
                  {benefitsData.benefit_details[dataIndex].value_or_description}
                </p>
              )}

              {isWorldTour && (
                <p
                  className='benefitsModalBenefitName'
                  style={{ fontWeight: 'bold' }}
                >
                  *Annual Conference Eligibility Will be Subject To The Full
                  Year Performance.
                </p>
              )}
              {isGoldenAgePlan && (
                <p
                  className='benefitsModalBenefitName'
                  style={{ fontWeight: 'bold', marginTop: '20px' }}
                >
                  {isRetailerLoggenIn &&
                    !unfilteredBenefitsData.show_50pc_gap_benefits_table &&
                    'Your GAP benefit is locked due to less than 50% onward allocation to shilpkaar/contractor'}
                  {isDistributorLoggenIn &&
                    !unfilteredBenefitsData.show_50pc_gap_benefits_table &&
                    'Your GAP benefit is locked due to less than 50% onward allocation to Dealer'}
                </p>
              )}

              {/* View More for GoldenAge */}
              {isGoldenAgePlan &&
                Number(
                  benefitsData?.benefit_details[dataIndex]
                    ?.value_or_description,
                ) > 0 && (
                  <>
                    <p
                      className='benefitsModalBenefitName'
                      style={{ margin: 0, fontSize: '15px', color: 'grey' }}
                    >
                      {isGoldenAgePlan && `For more details click here`}
                    </p>
                    <div className='displayCenter'>
                      <Button
                        block
                        type='primary'
                        style={{
                          width: '10rem',
                          marginBottom: '10px',
                          marginTop: '10px',
                        }}
                        onClick={() => {
                          navigate('/distributor/GoldenAgePlanListing', {
                            state: {
                              data: benefitsData?.benefit_details[dataIndex],
                            },
                          });
                        }}
                      >
                        <b className='btnText'>View More</b>
                      </Button>
                    </div>
                  </>
                )}
              <Row>
                <Col
                  span={16}
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <p
                    style={{
                      color: 'red',
                    }}
                  >
                    {isGoldenAgePlan &&
                      `*Subject to TDS under Section 194R of IT act`}
                  </p>
                </Col>
                <Col span={8}>
                  <SocialMediaButtons />
                </Col>
              </Row>
            </>
          )}
      </Modal>
    );
  };

  const Locked = () => {
    return (
      <>
        {unfilteredBenefitsData?.benefit_details &&
        unfilteredBenefitsData?.benefit_details.length > 0 ? (
          <>
            <img
              src={lockImageObj(
                unfilteredBenefitsData.benefit_details[0].value_or_description,
              )}
              alt='Benefits Locked Or Not Awarded'
              style={{
                height: '6rem',
                width: '6rem',
                position: 'absolute',
                bottom: 50,
              }}
            />
            <HexagonOutline
              width={260}
              height={260}
              strokeColor='#bfa166'
              strokeWidth={0}
              rotation={0}
              fill={overlayColorObj(
                unfilteredBenefitsData.benefit_details[0].value_or_description,
              )}
            />
          </>
        ) : (
          ''
        )}
      </>
    );
  };

  const benefitHasClub = (clubName) => {
    const benefitClubs = [
      'ब्रॉन्ज़',
      'प्लैटिनम',
      'सिल्वर',
      'गोल्ड',
      'डायमंड',
      'ब्लू',
    ];
    if (benefitClubs.includes(clubName)) return true;
    else return false;
  };
  const checkBenefitExists = (benefitName) => {
    return benefitsData.benefit_details.findIndex((i) =>
      i.name.includes(benefitName),
    );
  };
  return (
    <div>
      <Container
        maxWidth='true'
        sx={{
          pl: '2rem',
          pt: '5rem',
          height: window.innerHeight,
          overflowY: 'auto',
        }}
      >
        {modal()}
        <Spin spinning={loader}>
          {Object.keys(benefitsData).length > 0 ? (
            <div className='contentContainer benefitsContentContainer'>
              <div
                className='topContainer-username'
                style={{ textAlign: 'center' }}
              >
                <h3
                  style={{
                    color: '#af6a0e',
                    fontFamily: 'Noto Serif Georgian',
                  }}
                >
                  HI {loginUser?.first_name} {loginUser?.last_name}
                </h3>
              </div>

              {/* Category Section */}
              <div className='benefitsCategoryContainer'>
                <p className='benefitsCategoryHeader'>
                  MEMBER SINCE{' '}
                  {moment(unfilteredBenefitsData?.user_joining_date)
                    .format('DD MMM YYYY')
                    .toUpperCase()}
                </p>

                {benefitHasClub(
                  unfilteredBenefitsData?.benefit_details[0]
                    .value_or_description,
                ) === true ? (
                  <div className='displayCenter'>
                    {unfilteredBenefitsData?.benefit_details &&
                    unfilteredBenefitsData?.benefit_details.length > 0 ? (
                      <img
                        src={imageObj(
                          unfilteredBenefitsData.benefit_details[0]
                            .value_or_description,
                        )}
                        alt='Humbee Banner'
                        style={{ height: '12rem', width: '14rem' }}
                      />
                    ) : (
                      <Spin
                        style={{ height: '12rem', width: '14rem' }}
                        spinning={true}
                      />
                    )}
                  </div>
                ) : (
                  <p className='benefitsCategoryHeader'>
                    {' '}
                    <span style={{ color: 'blue' }}></span>{' '}
                  </p>
                )}

                <p className='benefitsCategoryHeader'>
                  {/* {unfilteredBenefitsData?.benefit_details &&
                  unfilteredBenefitsData?.benefit_details.length > 0 &&
                  unfilteredBenefitsData.benefit_details[0]
                    .value_or_description !== 'डायमंड'
                    ? `${
                        unfilteredBenefitsData?.next_level_volume_required
                      } TON MORE
                        LIFTING REQUIRED FOR ${nextLevelText(
                          unfilteredBenefitsData.benefit_details[0]
                            .value_or_description,
                        )}`
                    : ''} */}{' '}
                </p>
              </div>

              {/* ------ Welcome Heading ------- */}
              {unfilteredBenefitsData?.benefit_details[0]
                .value_or_description !== 'ब्लू' && (
                <div
                  className='topContainer-username displayCenter'
                  style={{ textAlign: 'center', flexDirection: 'column' }}
                >
                  <h2
                    style={{
                      color: '#af6a0e',
                      fontFamily: 'Noto Serif Georgian',
                    }}
                  >
                    WELCOME TO THE HUMBEE <br />
                    {unfilteredBenefitsData?.benefit_details &&
                    unfilteredBenefitsData?.benefit_details.length > 0 &&
                    benefitHasClub(
                      unfilteredBenefitsData?.benefit_details[0]
                        .value_or_description,
                    ) === true
                      ? `${levelText(
                          unfilteredBenefitsData?.benefit_details[0]
                            .value_or_description,
                        )}  CLUB CATEGORY`
                      : ''}
                  </h2>
                  <h4
                    style={{
                      color: '#af6a0e',
                      fontFamily: 'Noto Serif Georgian',
                      maxWidth: '18rem',
                    }}
                    found
                  >
                    *All the benefits are subject to TDS provisions Under
                    Section 194R of the Income tax
                  </h4>
                  <h4
                    style={{
                      color: '#af6a0e',
                      fontFamily: 'Noto Serif Georgian',
                      maxWidth: '20rem',
                      marginTop: '10px',
                    }}
                    found
                  >
                    BELOW ARE THE BENEFITS
                  </h4>
                </div>
              )}

              {/* Cards */}
              <div
                className='displayCenter'
                style={{ width: '100%', height: '100%' }}
              >
                <div
                  className='displayCenter'
                  style={{
                    width: '40rem',
                    height: '60rem',
                    backgroundImage:
                      'linear-gradient(to bottom, rgba(255,0,0,0), rgba(254,240,204,1) , rgba(254,240,204,.2))',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      flexWrap: 'wrap',
                      width: '100%',
                      height: '100%',
                    }}
                  >
                    {/* Life Insurance Card */}
                    <div
                      className='displayCenter'
                      style={{ position: 'relative', flex: 1 }}
                    >
                      <img
                        src={Shield}
                        alt='Humbee Banner'
                        style={{
                          height: '10rem',
                          width: '10rem',
                          margin: '60px',
                        }}
                      />

                      <img
                        onClick={() => {
                          const foundIndex =
                            benefitsData.benefit_details.findIndex((i) =>
                              i.name.includes('निश्चिंत (जीवन बीमा)'),
                            );
                          setDataIndex(foundIndex);
                          setOpenModal(true);
                          setModalData({
                            name: InsuranceText('निश्चिंत (जीवन बीमा)'),
                          });
                        }}
                        src={InfoIcon}
                        alt='Humbee Banner'
                        style={{
                          height: '3rem',
                          width: '3rem',
                          position: 'absolute',
                          top: 40,
                          right: 26,
                          zIndex: 1,
                        }}
                      />

                      {/* */}
                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#f1dc9c'
                        strokeWidth={2}
                        rotation={90}
                      />
                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#bfa166'
                        strokeWidth={2}
                        rotation={0}
                      />
                      {/* --- For Locking --- */}
                      {(!unfilteredBenefitsData.show_50pc_benefits_table ||
                        unfilteredBenefitsData?.benefit_details[0]
                          .value_or_description === 'ब्लू') && <Locked />}
                    </div>

                    {/* Medical Insurance Card */}
                    <div
                      className='displayCenter'
                      style={{ position: 'relative', flex: 1 }}
                    >
                      <img
                        src={Medical}
                        alt='Humbee Banner'
                        style={{
                          height: '10rem',
                          width: '10rem',
                          margin: '60px',
                        }}
                      />

                      <img
                        onClick={() => {
                          const foundIndex =
                            benefitsData.benefit_details.findIndex((i) =>
                              i.name.includes('संजीवनी (स्वास्थ्य बीमा)'),
                            );
                          setDataIndex(foundIndex);
                          setOpenModal(true);
                          setModalData({
                            name: InsuranceText('संजीवनी (स्वास्थ्य बीमा)'),
                          });
                        }}
                        src={InfoIcon}
                        alt='Humbee Banner'
                        style={{
                          height: '3rem',
                          width: '3rem',
                          position: 'absolute',
                          top: 40,
                          right: 26,
                          zIndex: 1,
                        }}
                      />

                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#f1dc9c'
                        strokeWidth={2}
                        rotation={90}
                      />
                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#bfa166'
                        strokeWidth={2}
                        rotation={0}
                      />
                      {/* --- For Locking --- */}
                      {(!unfilteredBenefitsData.show_50pc_benefits_table ||
                        unfilteredBenefitsData?.benefit_details[0]
                          .value_or_description === 'ब्लू') && <Locked />}
                    </div>

                    {/* Tour Card */}
                    <div
                      className='displayCenter'
                      style={{ position: 'relative', flex: 1 }}
                    >
                      <img
                        src={Aeroplance}
                        alt='Humbee Banner'
                        style={{
                          height: '10rem',
                          width: '14rem',
                          margin: '60px',
                        }}
                      />
                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#f1dc9c'
                        strokeWidth={2}
                        rotation={90}
                      />

                      <img
                        onClick={() => {
                          // toCertificate(certificateType.LifeInsurance);
                          const foundIndex = checkBenefitExists(
                            'सुहाना सफर (वार्षिक टूर)',
                          );
                          setDataIndex(foundIndex);
                          setOpenModal(true);
                          setModalData({
                            name: InsuranceText('सुहाना सफर (वार्षिक टूर)'),
                          });
                        }}
                        src={InfoIcon}
                        alt='Humbee Banner'
                        style={{
                          height: '3rem',
                          width: '3rem',
                          position: 'absolute',
                          top: 40,
                          right: 56,
                          zIndex: 1,
                        }}
                      />

                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#bfa166'
                        strokeWidth={2}
                        rotation={0}
                      />
                      {/* --- For Locking --- */}
                      {(!unfilteredBenefitsData.show_50pc_benefits_table ||
                        unfilteredBenefitsData?.benefit_details[0]
                          .value_or_description === 'ब्लू') && <Locked />}
                    </div>

                    {/* Golden age plan Card */}
                    <div
                      className='displayCenter'
                      style={{ position: 'relative', flex: 1 }}
                    >
                      <img
                        src={Beach}
                        alt='Humbee Banner'
                        style={{
                          height: '10rem',
                          width: '10rem',
                          margin: '60px',
                        }}
                      />

                      <img
                        onClick={() => {
                          const foundIndex =
                            benefitsData.benefit_details.findIndex((i) =>
                              i.name.includes(
                                'संबल/स्वावलंबन (गोल्डन एज प्लान)',
                              ),
                            );
                          setDataIndex(foundIndex);
                          setOpenModal(true);
                          setModalData({
                            name: InsuranceText(
                              'संबल/स्वावलंबन (गोल्डन एज प्लान)',
                            ),
                          });
                        }}
                        src={InfoIcon}
                        alt='Humbee Banner'
                        style={{
                          height: '3rem',
                          width: '3rem',
                          position: 'absolute',
                          top: 40,
                          right: 26,
                          zIndex: 1,
                        }}
                      />

                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#f1dc9c'
                        strokeWidth={2}
                        rotation={90}
                      />
                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#bfa166'
                        strokeWidth={2}
                        rotation={0}
                      />
                      {/* --- For Locking --- */}
                      {(!unfilteredBenefitsData.show_50pc_gap_benefits_table ||
                        unfilteredBenefitsData?.benefit_details[0]
                          .value_or_description === 'ब्लू') && <Locked />}
                    </div>
                    <div
                      className='displayCenter'
                      style={{ position: 'relative', flex: 1 }}
                    >
                      <img
                        src={shopInsurance}
                        alt='Humbee Banner'
                        style={{
                          height: '10rem',
                          width: '10rem',
                          margin: '60px',
                        }}
                      />

                      <img
                        onClick={() => {
                          const foundIndex =
                            benefitsData.benefit_details.findIndex((i) =>
                              i.name.includes('SHOP INSURANCE'),
                            );
                          setDataIndex(foundIndex);
                          setOpenModal(true);
                          setModalData({
                            name: InsuranceText('SHOP INSURANCE'),
                          });
                        }}
                        src={InfoIcon}
                        alt='Humbee Banner'
                        style={{
                          height: '3rem',
                          width: '3rem',
                          position: 'absolute',
                          top: 40,
                          right: 26,
                          zIndex: 1,
                        }}
                      />

                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#f1dc9c'
                        strokeWidth={2}
                        rotation={90}
                      />
                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#bfa166'
                        strokeWidth={2}
                        rotation={0}
                      />
                      {/* --- For Locking --- */}
                      {(!unfilteredBenefitsData.show_50pc_gap_benefits_table ||
                        unfilteredBenefitsData?.benefit_details[0]
                          .value_or_description === 'ब्लू') && <Locked />}
                    </div>
                    <div
                      className='displayCenter'
                      style={{ position: 'relative', flex: 1 }}
                    >
                      <img
                        src={staffInsurance}
                        alt='Humbee Banner'
                        style={{
                          height: '10rem',
                          width: '10rem',
                          margin: '60px',
                        }}
                      />

                      <img
                        onClick={() => {
                          const foundIndex =
                            benefitsData.benefit_details.findIndex((i) =>
                              i.name.includes('STAFF INSURANCE'),
                            );
                          setDataIndex(foundIndex);
                          setOpenModal(true);
                          setModalData({
                            name: InsuranceText('STAFF INSURANCE'),
                          });
                        }}
                        src={InfoIcon}
                        alt='Humbee Banner'
                        style={{
                          height: '3rem',
                          width: '3rem',
                          position: 'absolute',
                          top: 40,
                          right: 26,
                          zIndex: 1,
                        }}
                      />

                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#f1dc9c'
                        strokeWidth={2}
                        rotation={90}
                      />
                      <HexagonOutline
                        width={240}
                        height={240}
                        strokeColor='#bfa166'
                        strokeWidth={2}
                        rotation={0}
                      />
                      {/* --- For Locking --- */}
                      {(!unfilteredBenefitsData.show_50pc_gap_benefits_table ||
                        unfilteredBenefitsData?.benefit_details[0]
                          .value_or_description === 'ब्लू') && <Locked />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div
              className='topContainer-username displayCenter'
              style={{ textAlign: 'center', height: '100%' }}
            >
              <h3
                style={{
                  color: '#af6a0e',
                  fontFamily: 'Noto Serif Georgian',
                  padding: '100px',
                }}
              >
                HI {loginUser?.first_name} {loginUser?.last_name} CURRENTLY NO
                BENEFITS AVAILABLE FOR YOU
              </h3>
            </div>
          )}
        </Spin>
      </Container>
    </div>
  );
};

export default MyBenefits;
